import {
  JsonapiEntity,
  attribute,
  entity,
  relationship,
} from 'jsonapi-transformers';

import { Bookstore } from './bookstore';
import { CitationStyle } from './citation-style';
import { Importance } from './importance';
import { License } from './license';
import { ListAccess } from './list-access';
import { Period } from './period';
import { Report } from './report';

@entity({ type: 'tenants' })
export class Tenant extends JsonapiEntity<Tenant> {
  @attribute() base_uri: string;
  @attribute() default_list_access: ListAccess | null;
  @attribute() login_provider: string;
  @attribute() name: string;
  @attribute() persona_host: string;
  @attribute() short_code: string;
  @attribute() active_locales: string[];
  @attribute() default_locale: string;
  @attribute() required_item_importances: string;
  @relationship() bookstores: Bookstore[];
  @relationship() citation_styles: CitationStyle[];
  @relationship() importances: Importance[];
  @relationship() licenses: License[] | null;
  @relationship() periods: Period[] | null;
  @relationship() reports: Report[] | null;
}

export enum TenantType {
  ASPIRE = 'aspire',
  COURSEFLOW = 'courseflow',
}
